import dayjs, { Dayjs } from "dayjs";

export const MIN_INVOICE_AMOUNT = 10;

export const MIN_INVOICE_AMOUNT_MESSAGE =
    "O valor total do montante não pode ser inferior a R$ 10,00 (valor mínimo).";

export const MIN_DUE_DATE_MESSAGE =
    "A data de vencimento não pode ser anterior ao dia de hoje.";

export const isValidInvoiceAmount = (amount: number): boolean =>
    Number.isFinite(amount) && amount >= MIN_INVOICE_AMOUNT;

export function getProductsTotalAmount(
    products: Array<{ amount?: number | string | null }>
): number {
    return products.reduce((total, product) => {
        const amount = Number(product.amount ?? 0);
        return total + (Number.isFinite(amount) ? amount : 0);
    }, 0);
}

export function getProjectedInvoiceTotalOnEdit(
    products: Array<{ id?: number; amount?: number | string | null }>,
    editedProductId: number,
    editedAmount: number
): number {
    return products.reduce((total, product) => {
        if (Number(product.id) === Number(editedProductId)) {
            return total + Number(editedAmount || 0);
        }

        const amount = Number(product.amount ?? 0);
        return total + (Number.isFinite(amount) ? amount : 0);
    }, 0);
}

export function getProjectedInvoiceTotalOnAdd(
    currentTotal: number,
    additionalAmount: number
): number {
    return Number(currentTotal || 0) + Number(additionalAmount || 0);
}

export const isValidDueDate = (date: Dayjs | null): boolean => {
    if (!date) {
        return false;
    }

    return !date.isBefore(dayjs().startOf("day"), "day");
};
